import { render, staticRenderFns } from "./ShipmentFilter.vue?vue&type=template&id=2d869c8e&"
import script from "./ShipmentFilter.vue?vue&type=script&lang=js&"
export * from "./ShipmentFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports